import {
  SupportTicketCategory,
  SupportTicketStatus,
} from "../@types/support";

export const SUPPORT_EMAIL = "contact@mountmonitor.com";

export const SUPPORT_CATEGORIES: {
  value: SupportTicketCategory;
  label: string;
  description: string;
  minMessageLength: number;
}[] = [
  {
    value: "issue",
    label: "Issue",
    description: "Something is broken or not working as expected",
    minMessageLength: 60,
  },
  {
    value: "question",
    label: "Question",
    description: "Help with how something works",
    minMessageLength: 20,
  },
  {
    value: "suggestion",
    label: "Suggestion",
    description: "An improvement or new feature you would like to see",
    minMessageLength: 20,
  },
];

export const getSupportCategory = (value: SupportTicketCategory) =>
  SUPPORT_CATEGORIES.find((c) => c.value === value) ?? SUPPORT_CATEGORIES[0];

export const SUPPORT_STATUSES: Record<
  SupportTicketStatus,
  { label: string; color: string; description: string }
> = {
  open: {
    label: "Open",
    color: "blue",
    description: "Received. We will pick this up shortly.",
  },
  in_progress: {
    label: "In progress",
    color: "yellow",
    description: "We are working on it.",
  },
  waiting_on_you: {
    label: "Waiting on you",
    color: "orange",
    description: "We need more information from you to continue.",
  },
  resolved: {
    label: "Resolved",
    color: "green",
    description: "This ticket has been resolved.",
  },
};

export const SUPPORT_AFFECTED_AREAS = [
  "Reporting Dashboard",
  "Jobs Board",
  "Clients Board",
  "New Job",
  "New Client",
  "Update Job",
  "Update Client",
  "Invoices",
  "Card Reader",
  "Payments",
  "Inventory",
  "Expenses",
  "Reports",
  "Permissions",
  "Settings",
  "QuickBooks",
  "Portal",
  "Tutorials",
  "Other",
];
